module.exports = __webpack_public_path__ + "static/media/LB-Logo.6a9fa63a.png";